import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Antes sentía que tenía demasiada información y cero dirección. Link Academy me dio una ruta clara para empezar.',
    name: 'María G.',
    role: 'Emprendedora'
  }, {
    quote: 'Alice me ayudó a ordenar mis ideas y convertirlas en una estrategia mucho más concreta.',
    name: 'Carlos R.',
    role: 'Creador de contenido'
  }, {
    quote: 'Lo mejor es no sentir que estoy aprendiendo sola. La comunidad y las mentorías hacen la diferencia.',
    name: 'Laura M.',
    role: 'Estudiante'
  }];
  return <section id="testimonios" className="py-12 lg:py-16 bg-gray-50" data-id="element-245">
      <div className="container mx-auto px-4 md:px-6" data-id="element-246">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold text-link-dark mb-6" data-id="element-248">
            Personas como tú ya están construyendo su camino digital
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-249">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 relative" data-id="element-250">
              <Quote className="absolute top-6 right-6 text-link-light" size={40} data-id="element-251" />

              <div className="flex items-center gap-4 mb-6" data-id="element-252">
                <div className="w-12 h-12 rounded-full bg-link-blue text-white flex items-center justify-center font-bold text-lg" data-id="element-253">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-254">
                  <h4 className="font-bold text-link-dark" data-id="element-255">
                    {testimonial.name}
                  </h4>
                  <span className="text-sm text-gray-500" data-id="element-256">
                    {testimonial.role}
                  </span>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed italic relative z-10" data-id="element-257">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}